import { memo, useMemo } from 'react';
import type { ComponentType, MemoExoticComponent, ReactElement } from 'react';
import deepEqual from 'fast-deep-equal';
import { createStore, Provider } from 'jotai';
import { sectionContainerAtom } from '@ingenico/react-section-utils';
import { deviceManagementContainer } from '../container.const';

export function withDeviceManagementContainer<T = {}>(
  Component: ComponentType<T>,
): MemoExoticComponent<ComponentType<T>> {
  function ExposedComponent(props: T): ReactElement {
    const store = useMemo(() => {
      const sectionStore = createStore();
      sectionStore.set(sectionContainerAtom, deviceManagementContainer);
      return sectionStore;
    }, []);

    return (
      <Provider store={store}>
        <Component {...props} />
      </Provider>
    );
  }

  return memo(ExposedComponent, deepEqual);
}
